module.exports = __webpack_public_path__ + "static/media/slide7.63a985fb.jpg";